exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* On small screens, the nav menu spans the full width of the screen. Leave a space for it. */\n/* On small screens, the nav menu spans the full width of the screen. Leave a space for it. */\n.transition-block {\n  background: #eee;\n  float: left;\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  margin: 5px; }\n\n.body-content {\n  min-height: 100vh;\n  overflow: hidden; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = main